/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSettingRequestContent
 */
export interface UpdateSettingRequestContent {
    /**
     * 
     * @type {any}
     * @memberof UpdateSettingRequestContent
     */
    updatedSetting: any | null;
}


/**
 * Check if a given object implements the UpdateSettingRequestContent interface.
 */
export function instanceOfUpdateSettingRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updatedSetting" in value;

    return isInstance;
}

export function UpdateSettingRequestContentFromJSON(json: any): UpdateSettingRequestContent {
    return UpdateSettingRequestContentFromJSONTyped(json, false);
}

export function UpdateSettingRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSettingRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updatedSetting': json['updatedSetting'],
    };
}

export function UpdateSettingRequestContentToJSON(value?: UpdateSettingRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updatedSetting': value.updatedSetting,
    };
}

